var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "d-flex flex-column h-100 justify-content-center" },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-sm-8 offset-sm-2 col-lg-6 offset-lg-3" },
            [
              _vm._m(0),
              _c("div", { staticClass: "p-3" }, [
                _c("h3", { staticClass: "text-uppercase text-center" }, [
                  _vm._v(" Réinitialiser votre mot de passe ")
                ]),
                _c("div", { staticClass: "mt-2" }, [
                  !_vm.challengeError
                    ? _c("div", { staticClass: "form-floating mt-4" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password1,
                              expression: "password1"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "password",
                            id: _vm.userTypeId + "_password1",
                            name: _vm.userTypeId + "_password1",
                            placeholder: "Mot de passe",
                            required: ""
                          },
                          domProps: { value: _vm.password1 },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.password1 = $event.target.value
                              },
                              _vm.verfiyFormatPassword
                            ]
                          }
                        }),
                        _c(
                          "label",
                          { attrs: { for: _vm.userTypeId + "_password1" } },
                          [_vm._v("Nouveau mot de passe")]
                        )
                      ])
                    : _vm._e(),
                  !_vm.challengeError
                    ? _c("div", { staticClass: "form-floating mt-3" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password2,
                              expression: "password2"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "password",
                            id: _vm.userTypeId + "_password2",
                            name: _vm.userTypeId + "_password2",
                            placeholder: "Répétez le mot de passe",
                            required: ""
                          },
                          domProps: { value: _vm.password2 },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.password2 = $event.target.value
                              },
                              _vm.verifyPassword
                            ]
                          }
                        }),
                        _c(
                          "label",
                          { attrs: { for: _vm.userTypeId + "_password2" } },
                          [_vm._v("Nouveau mot de passe")]
                        )
                      ])
                    : _vm._e(),
                  _vm.dialogErr
                    ? _c("div", { staticClass: "alert alert-danger mt-3" }, [
                        _vm._v(" " + _vm._s(_vm.dialogErrTxt) + " ")
                      ])
                    : _vm._e(),
                  !_vm.challengeError
                    ? _c("div", { staticClass: "mt-3" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-lg btn-primary",
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "button",
                              disabled: !_vm.isValid1 || !_vm.isValid2
                            },
                            on: {
                              click: function($event) {
                                return _vm.newpassword()
                              }
                            }
                          },
                          [_vm._v(" Réinitialiser ")]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "modal fade",
              attrs: { id: "modalResetPassword", role: "dialog" }
            },
            [
              _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-body p-4" }, [
                    _vm._v(" Votre mot de passe a bien été modifié. ")
                  ]),
                  _c("div", { staticClass: "modal-footer text-end" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: { click: _vm.goToLogin }
                      },
                      [_vm._v(" Se connecter ")]
                    )
                  ])
                ])
              ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center mb-4 d-none d-lg-block" }, [
      _c("img", {
        staticClass: "company-logo",
        attrs: { src: "/images/logo_emotivi.png", alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }